import { render, staticRenderFns } from "./PuntosImpresion.vue?vue&type=template&id=4f07d5c6&scoped=true&"
import script from "./PuntosImpresion.vue?vue&type=script&lang=js&"
export * from "./PuntosImpresion.vue?vue&type=script&lang=js&"
import style0 from "./PuntosImpresion.vue?vue&type=style&index=0&id=4f07d5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f07d5c6",
  null
  
)

export default component.exports